import { render } from "./EditAgencyUser.vue?vue&type=template&id=15e49bbb&scoped=true&ts=true"
import script from "./EditAgencyUser.vue?vue&type=script&lang=ts"
export * from "./EditAgencyUser.vue?vue&type=script&lang=ts"

import "./EditAgencyUser.vue?vue&type=style&index=0&id=15e49bbb&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e49bbb"]])

export default __exports__